import { Injectable } from "@angular/core";

import MD5 from "md5-es";
import { Observable, throwError } from "rxjs";
import { catchError, first } from "rxjs/operators";

import { DffError } from "@dffedb/util";
import { LocalStorage } from "@dffedb/util";
import { AppserverInstallationCredentialsRepository } from "@e-forsyning/common/credentials";
import { IInstallationsoplysninger } from "@e-forsyning/common/installation";
import { ILoginoplysninger, LoginoplysningerRepository } from "@e-forsyning/common/loginoplysninger";

import { ValgtForbrugerObserver } from "../bruger/valgt-forbruger.observer";
import { ValgtInstallationRepository } from "./valgt-installation.repository";

@Injectable({ providedIn: "root" })
export class ValgtInstallationService {
    constructor(
        private readonly localStorage: LocalStorage,
        private readonly valgtInstallationRepository: ValgtInstallationRepository,
        private readonly credentialsRepository: AppserverInstallationCredentialsRepository,
        private readonly loginoplysningerRepository: LoginoplysningerRepository,
        private readonly valgtForbrugerObserver: ValgtForbrugerObserver
    ) {}

    public hentInstallationsoplysninger(): Observable<IInstallationsoplysninger> {
        return this.valgtInstallationRepository.hentInstallationsoplysninger().pipe(
            catchError((e) =>
                throwError(
                    new DffError(e.message, {
                        friendlyMessage: "Fejl i hent installationsoplysninger.",
                        innerError: e,
                        showNotification: true
                    })
                )
            )
        );
    }

    public async redigerTelefonnr(telefonnr: string): Promise<void> {
        await this.valgtInstallationRepository.redigerTelefonnummer(telefonnr);
        this.localStorage.setItem("remindMe", "NO");
    }

    public async redigerBeboeremail(beboeremail: string): Promise<void> {
        await this.valgtInstallationRepository.redigerBeboeremail(beboeremail);
        this.localStorage.setItem("remindMe", "NO");
    }

    public async redigerMail(mail: string): Promise<void> {
        await this.valgtInstallationRepository.redigerMail(mail);
        this.localStorage.setItem("remindMe", "NO");
    }

    public async redigerLoginoplysninger(loginoplysninger: ILoginoplysninger): Promise<void> {
        const valgtBruger = await this.valgtForbrugerObserver.valueChanges.pipe(first()).toPromise();
        loginoplysninger.nytKodeord = MD5.hash(loginoplysninger.nytKodeord);
        loginoplysninger.nuvaerendeKodeord = MD5.hash(loginoplysninger.nuvaerendeKodeord);
        loginoplysninger.brugerId = valgtBruger.id;

        return await this.loginoplysningerRepository.redigerLoginoplysninger(loginoplysninger);
    }

    public hentEjendomNr(): number {
        return this.credentialsRepository.hent().ejendomNr;
    }

    public hentAktivNr(): number {
        return this.credentialsRepository.hent().aktivNr;
    }

    public hentInstallationNr(): number {
        return this.credentialsRepository.hent().installationNr;
    }

    public hentForsyningId(): string {
        return this.credentialsRepository.hent().forsyningId;
    }
}
